module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suchen({0})","select":"Auswählen","sort_by":"Sortiere nach","no_data_text":"keine Daten","no_result_text":"Es wurde nichts zu Ihrer Suchanfrage gefunden"},"en":{"search":"Search({0})","select":"Select","sort_by":"Sort by","no_data_text":"No data","no_result_text":"Nothing was found for your search request"}}')
  delete Component.options._Ctor
}
